export const DataType = {
  text: "text",
  numeric: "number",
  int: "int",
  bool: "bool",
  value: "value",
  enum: "enum",
  date: "date",
  dateTime: "datetime",
  dateFrom: "dateFrom",
  html: "html",
  list: "list",
  template: "template",
};
